import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const userMetricsPlugin = createPlugin({
  id: 'user-metrics',
  routes: {
    root: rootRouteRef,
  },
});

export const UserMetricsPage = userMetricsPlugin.provide(
  createRoutableExtension({
    name: 'UserMetricsPage',
    component: () =>
      import('./components/OptimizedUserMetricsPage').then(
        m => m.OptimizedUserMetricsPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
